// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    display: flex;
    flex-direction: column;
  }
  
  .dashboard-layout {
    display: flex;
  }
  
  .dashboard-main {
    flex-grow: 1;
    padding: 0 20px;
  }
  
 .dashboard-content {
    padding: 1rem;
    background-color: #f5f5f5;
    height: calc(100% - 60px); /* Adjust height to account for the header */
    overflow-y: auto;
    margin-top: 20px;
 }

 dashboard-content h2 {
    color: #000;
    margin-top: 0;
    padding-top: 10px;
 }

 /* General Styles */
.senderid-add {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
  }
  
  .tab {
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    border: 1px solid #ddd;
    background-color: #f5f5f5;
    color: #333;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    border-radius: 5px;
  }
  
  .tab.active {
    background-color: #ffcc29;
    color: #000;
    border-color: #ffcc29;
  }
  
  /* Add and Upload Section */
  .add-section-senderId, 
  .upload-section-senderId {
    border: 1px solid #ddd;
    max-width: 800px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center; 
    border-radius: 8px;
    margin: 20px auto;
    padding: 20px;
  }

  .senderid-option-radio {
    display: flex;
    flex-wrap: wrap; 
    align-items: center;
    gap: 15px; 
    margin-bottom: 15px;
    width: 100%; 
  }
  
  .senderid-option-radio label {
    /* flex: 0 0 163px; */
    font-size: 14px;
    font-weight: 600;
    color: #555;
    text-align: justify;
    white-space: nowrap;
    margin-right: 90px;
  }
  
  .senderid-option-radio .wrap-radio-btns {
    display: flex;
    flex-wrap: wrap; 
    gap: 15px; 
    flex-grow: 1;
  }
  
  .senderid-option-radio .wrap-radio-btns label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: normal;
    color: #333;
  }
  
  .senderid-option-radio input[type="radio"] {
    margin-right: 5px; 
  }
  
  @media screen and (max-width: 800px) {

    .senderid-option-radio label {
        flex: 0 0 auto;
    }

    .senderid-option-radio {
      align-items: flex-start;
    }
  
    .senderid-option-radio .wrap-radio-btns {
      width: 100%; /* Ensures full width on smaller screens */
    }
  }
  
  .senderid-option-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 15px; 
    width: 100%
  }
  
  .senderid-option-wrap label {
    flex: 0 0 200px; /* Fixed width for labels */
    font-size: 14px;
    font-weight: 600;
    color: #555;
    margin-bottom: 0;
    text-align: justify;
  }
  
  .senderid-option-wrap input[type="text"],
  .senderid-option-wrap input[type="file"] {
    flex: 1 1;
    width: 100%;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  /* For radio button groups */
  .wrap-radio-btns {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .btn {
    display: inline-block;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: bold;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .submit-buttons {
    color: #fff;
    background-color: #44a67e;
    border-color: #44a67e !important;
  }
  
  /* .submit-buttons:hover {
    background-color: #218838;
  } */

  .upload-buttons {
    color: #fff;
    background-color: #44a67e;
    border-color: #44a67e;
  }

  .upload-buttons:disabled {
    background-color: #a9a9a9;
    cursor: not-allowed;
    opacity: 0.8;
  }
  
  /* .upload-buttons:hover {
    background-color: #218838;
  } */

  .responseMsg {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
  }

  .responseMsg p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }

  .wrap-add-senderid {
    margin: 0 40px;
  }

  /* search filter */
  .senderid-search-filter {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 20px;
  }
  
  .senderid-search-filter input {
    width: 250px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }

  /* Table Styling======================================================= */
  .addSenderId-table-container {
    width: 100%;
    overflow-x: auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }
  
  .addSenderId-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .addSenderId-table th,
  .addSenderId-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .addSenderId-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .addSenderId-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .addSenderId-table tbody tr:hover {
    background-color: rgba(255, 204, 41, 0.2);
  }
  
  .addSenderId-table td {
    color: #373435;
  }
  
  .addSenderId-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }

  .addSenderId-table .delete-btn {
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
  }
  
  /* Expand Button */
  .senderid-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .senderid-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }
  
  /* Expanded Row */
  .sender-idexpanded-row {
    background-color: #eef7ff;
  }
  
  .senderid-expanded-content {
    padding: 10px;
  }
  
  /* Responsive Styles */
 
/* ------------------------------------------------------------------------------------ */
  
  /* Button Styling */
  .delete-btn {
    background-color: #dc3545;
    color: white;
    padding: 5px 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .delete-btn:hover {
    background-color: #c82333;
  }

  @media (max-width: 950px) {
    .table-container {
      overflow-x: auto;
    }
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .senderid-add {
      flex-direction: column;
      gap: 10px;
    }
  
    .tab {
      font-size: 14px;
      padding: 8px 15px;
    }
  
    .senderid-option-wrap input[type="text"],
    .senderid-option-wrap input[type="file"] {
      font-size: 12px;
    }
  
    .btn {
      font-size: 12px;
      padding: 8px 15px;
    }
  }
  
/* ==========Message Note Style=========  */
  .senderid-option-wrap .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .senderid-option-wrap .note {
    /* color: #373435;
    font-size: 12px;
    text-align: start; */
    font-size: 0.9em;
    color: #44a67e;
    font-size: 13px !important;
    font-style: italic;
    text-align: start;
    font-weight: 550;
  }

  .senderid-option-wrap .file-name {
    color: #44a67e !important;
    font-size: 16px !important;
    text-align: start;
  }`, "",{"version":3,"sources":["webpack://./src/components/AddSenderId/AddSenderId.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;CAED;IACG,aAAa;IACb,yBAAyB;IACzB,yBAAyB,EAAE,4CAA4C;IACvE,gBAAgB;IAChB,gBAAgB;CACnB;;CAEA;IACG,WAAW;IACX,aAAa;IACb,iBAAiB;CACpB;;CAEA,mBAAmB;AACpB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB;;EAEA,2BAA2B;EAC3B;;IAEE,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE;QACI,cAAc;IAClB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,WAAW,EAAE,0CAA0C;IACzD;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT;EACF;;EAEA;IACE,eAAe,EAAE,2BAA2B;IAC5C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,SAAO;IACP,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;;KAEG;;EAEH;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;;EAEA;;KAEG;;EAEH;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,yEAAyE;EACzE;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA,sBAAsB;;AAExB,yFAAyF;;EAEvF,mBAAmB;EACnB;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;;MAEE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;;AAEF,2CAA2C;EACzC;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE;;wBAEoB;IACpB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;EACnB","sourcesContent":[".dashboard-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .dashboard-layout {\r\n    display: flex;\r\n  }\r\n  \r\n  .dashboard-main {\r\n    flex-grow: 1;\r\n    padding: 0 20px;\r\n  }\r\n  \r\n .dashboard-content {\r\n    padding: 1rem;\r\n    background-color: #f5f5f5;\r\n    height: calc(100% - 60px); /* Adjust height to account for the header */\r\n    overflow-y: auto;\r\n    margin-top: 20px;\r\n }\r\n\r\n dashboard-content h2 {\r\n    color: #000;\r\n    margin-top: 0;\r\n    padding-top: 10px;\r\n }\r\n\r\n /* General Styles */\r\n.senderid-add {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .tab {\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    border: 1px solid #ddd;\r\n    background-color: #f5f5f5;\r\n    color: #333;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, color 0.3s;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .tab.active {\r\n    background-color: #ffcc29;\r\n    color: #000;\r\n    border-color: #ffcc29;\r\n  }\r\n  \r\n  /* Add and Upload Section */\r\n  .add-section-senderId, \r\n  .upload-section-senderId {\r\n    border: 1px solid #ddd;\r\n    max-width: 800px;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; \r\n    justify-content: center; \r\n    border-radius: 8px;\r\n    margin: 20px auto;\r\n    padding: 20px;\r\n  }\r\n\r\n  .senderid-option-radio {\r\n    display: flex;\r\n    flex-wrap: wrap; \r\n    align-items: center;\r\n    gap: 15px; \r\n    margin-bottom: 15px;\r\n    width: 100%; \r\n  }\r\n  \r\n  .senderid-option-radio label {\r\n    /* flex: 0 0 163px; */\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #555;\r\n    text-align: justify;\r\n    white-space: nowrap;\r\n    margin-right: 90px;\r\n  }\r\n  \r\n  .senderid-option-radio .wrap-radio-btns {\r\n    display: flex;\r\n    flex-wrap: wrap; \r\n    gap: 15px; \r\n    flex-grow: 1;\r\n  }\r\n  \r\n  .senderid-option-radio .wrap-radio-btns label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    color: #333;\r\n  }\r\n  \r\n  .senderid-option-radio input[type=\"radio\"] {\r\n    margin-right: 5px; \r\n  }\r\n  \r\n  @media screen and (max-width: 800px) {\r\n\r\n    .senderid-option-radio label {\r\n        flex: 0 0 auto;\r\n    }\r\n\r\n    .senderid-option-radio {\r\n      align-items: flex-start;\r\n    }\r\n  \r\n    .senderid-option-radio .wrap-radio-btns {\r\n      width: 100%; /* Ensures full width on smaller screens */\r\n    }\r\n  }\r\n  \r\n  .senderid-option-wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n    gap: 15px; \r\n    width: 100%\r\n  }\r\n  \r\n  .senderid-option-wrap label {\r\n    flex: 0 0 200px; /* Fixed width for labels */\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #555;\r\n    margin-bottom: 0;\r\n    text-align: justify;\r\n  }\r\n  \r\n  .senderid-option-wrap input[type=\"text\"],\r\n  .senderid-option-wrap input[type=\"file\"] {\r\n    flex: 1;\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 14px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  /* For radio button groups */\r\n  .wrap-radio-btns {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .btn {\r\n    display: inline-block;\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .submit-buttons {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border-color: #44a67e !important;\r\n  }\r\n  \r\n  /* .submit-buttons:hover {\r\n    background-color: #218838;\r\n  } */\r\n\r\n  .upload-buttons {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n  }\r\n\r\n  .upload-buttons:disabled {\r\n    background-color: #a9a9a9;\r\n    cursor: not-allowed;\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  /* .upload-buttons:hover {\r\n    background-color: #218838;\r\n  } */\r\n\r\n  .responseMsg {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .responseMsg p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n\r\n  .wrap-add-senderid {\r\n    margin: 0 40px;\r\n  }\r\n\r\n  /* search filter */\r\n  .senderid-search-filter {\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .senderid-search-filter input {\r\n    width: 250px;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  /* Table Styling======================================================= */\r\n  .addSenderId-table-container {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    margin-top: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    background: #fff;\r\n  }\r\n  \r\n  .addSenderId-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .addSenderId-table th,\r\n  .addSenderId-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .addSenderId-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .addSenderId-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .addSenderId-table tbody tr:hover {\r\n    background-color: rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .addSenderId-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .addSenderId-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n\r\n  .addSenderId-table .delete-btn {\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n  }\r\n  \r\n  /* Expand Button */\r\n  .senderid-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .senderid-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n  \r\n  /* Expanded Row */\r\n  .sender-idexpanded-row {\r\n    background-color: #eef7ff;\r\n  }\r\n  \r\n  .senderid-expanded-content {\r\n    padding: 10px;\r\n  }\r\n  \r\n  /* Responsive Styles */\r\n \r\n/* ------------------------------------------------------------------------------------ */\r\n  \r\n  /* Button Styling */\r\n  .delete-btn {\r\n    background-color: #dc3545;\r\n    color: white;\r\n    padding: 5px 10px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .delete-btn:hover {\r\n    background-color: #c82333;\r\n  }\r\n\r\n  @media (max-width: 950px) {\r\n    .table-container {\r\n      overflow-x: auto;\r\n    }\r\n  }\r\n  \r\n  /* Responsive Design */\r\n  @media (max-width: 768px) {\r\n    .senderid-add {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n  \r\n    .tab {\r\n      font-size: 14px;\r\n      padding: 8px 15px;\r\n    }\r\n  \r\n    .senderid-option-wrap input[type=\"text\"],\r\n    .senderid-option-wrap input[type=\"file\"] {\r\n      font-size: 12px;\r\n    }\r\n  \r\n    .btn {\r\n      font-size: 12px;\r\n      padding: 8px 15px;\r\n    }\r\n  }\r\n  \r\n/* ==========Message Note Style=========  */\r\n  .senderid-option-wrap .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  \r\n  .senderid-option-wrap .note {\r\n    /* color: #373435;\r\n    font-size: 12px;\r\n    text-align: start; */\r\n    font-size: 0.9em;\r\n    color: #44a67e;\r\n    font-size: 13px !important;\r\n    font-style: italic;\r\n    text-align: start;\r\n    font-weight: 550;\r\n  }\r\n\r\n  .senderid-option-wrap .file-name {\r\n    color: #44a67e !important;\r\n    font-size: 16px !important;\r\n    text-align: start;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
